/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Import_Phase_ImportingInputs */

const en_ui_import_phase_importing = /** @type {(inputs: Ui_Import_Phase_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing your sessions`)
};

const de_ui_import_phase_importing = /** @type {(inputs: Ui_Import_Phase_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Einheiten werden importiert`)
};

/**
* | output |
* | --- |
* | "Importing your sessions" |
*
* @param {Ui_Import_Phase_ImportingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_import_phase_importing = /** @type {((inputs?: Ui_Import_Phase_ImportingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Import_Phase_ImportingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_import_phase_importing(inputs)
	return de_ui_import_phase_importing(inputs)
});